import {ACTION} from "../actionTypes";
import AppContainer from "../../AppContainer";

export const reduxHandleUnauthorized = () => {
    AppContainer.getContainer().getReduxStore().dispatch({
        type: ACTION.CREDENTIALS.DELETE
    });
};
